export const partnersData = [
  {
    sectionTitle: 'Generative AI Companies',
    logos: ['microsoft', 'meta', 'openai', 'cohere', 'adept', 'carper', 'stability', 'characterai']
  },
  {
    sectionTitle: 'U.S. Government Agencies',
    logos: ['usarmy', 'airforce', 'defense', 'cdao']
  },
  {
    sectionTitle: 'Enterprises',
    logos: ['microsoft', 'meta', 'gm', 'toyota', 'fox', 'accenture', 'koch']
  },
  {
    sectionTitle: 'Startups',
    logos: ['brex', 'flexport', 'instacart', 'faire', 'opensea', 'etsy']
  }
];
